module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"OurPokerGame - The easy, free way to play online poker with your friends","short_name":"Poker","start_url":"/","background_color":"#2B3D4F","theme_color":"#2B3D4F","display":"minimal-ui","icon":"src/images/logo/icon.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
